import { TranslocoService } from '@jsverse/transloco';
import { Component, Input, OnInit, inject } from '@angular/core';
import { KpiWidgetComponent } from '../../../../../../_shared/components/kpi-widget/kpi-widget.component';
import { BaseWidgetComponent } from '../../../../../../home/home-widgets/widgets/base-widget.component';
import { FilterService } from '../../../../../../_shared/services';
import { transformValue } from '../../../../../../_shared/helpers/kpiWidget/kpi-formatters.helper';
import { ErrorHandlerService } from '../../../../../../_shared/services/error-handler.service';
import { ComplianceOverviewService } from '../../../../compliance-overview/services/compliance-overview.service';

@Component({
  selector: 'app-pass-widget',
  standalone: true,
  imports: [
    KpiWidgetComponent
  ],
  templateUrl: './pass-widget.component.html',
  styleUrl: './pass-widget.component.scss'
})
export class PassWidgetComponent extends BaseWidgetComponent implements OnInit {
  private complianceOverviewService = inject(ComplianceOverviewService);
  private errorHandlerService = inject(ErrorHandlerService);

  @Input() assetId?: number;
  @Input() complianceId?: number;
  @Input() taskId?: number | null;
  @Input() source: 'periodic' | 'routine' = 'periodic';

  hasError: boolean = false;
  errorMessage: string = '';

  constructor() {
    const filterService: FilterService = inject(FilterService);
    super(filterService);
    this.title = inject(TranslocoService).translate('compliance.shared.widgets.pass');
    this.isLoading = true;
    this.value = 0;
    this.widgetDisabled = true;
  }

  async ngOnInit(): Promise<void> {
    await this.loadPassSummaryAsync();
  }

  public override formatValue(value: number): string {
    return `${transformValue(value)}`;
  }

  private async loadPassSummaryAsync(): Promise<void> {
    if (!this.assetId || !this.complianceId) {
      this.isLoading = false;
      return;
    }

    this.hasError = false;
    this.errorMessage = '';
    this.isLoading = true;

    try {
      this.cancelSubject.next();
      const request = { assetId: this.assetId, complianceId: this.complianceId, taskId: this.taskId };
      const response = this.source === 'routine'
        ? await this.complianceOverviewService.getAssetRoutineCompliancePassSummaryAsync(request, this.cancelSubject)
        : await this.complianceOverviewService.getAssetCompliancePassSummaryAsync(request, this.cancelSubject);
      this.value = response?.data?.totalValue ?? 0;
      this.isLoading = false;
    } catch (error) {
      this.errorHandlerService.handleError(error, {
        callback: (message) => {
          this.errorMessage = message;
          this.hasError = true;
          this.isLoading = false;
        }
      });
    }
  }

  protected override async onFilterChangeAsync(): Promise<void> {}
}